var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import CleverSvg from './clever.svg';
import ClassLinkSvg from './classlink.svg';
import StarSvg from './star.svg';
import StarHalfSvg from './star-half.svg';
import StarHalf2Svg from './star-half2.svg';
import ArrowLeftSvg from './arrow-left.svg';
import ArrowRightSvg from './arrow-right.svg';
export var CleverIcon = function (props) { return (_jsx(CleverSvg, __assign({}, props), void 0)); };
export var ClassLinkIcon = function (props) { return (_jsx(ClassLinkSvg, __assign({}, props), void 0)); };
export var StarIcon = function (props) { return (_jsx(StarSvg, __assign({}, props), void 0)); };
export var StarHalfIcon = function (props) { return (_jsx(StarHalfSvg, __assign({}, props), void 0)); };
export var StarHalf2Icon = function (props) { return (_jsx(StarHalf2Svg, __assign({}, props), void 0)); };
export var ArrowLeftIcon = function (props) { return (_jsx(ArrowLeftSvg, __assign({}, props), void 0)); };
export var ArrowRightIcon = function (props) { return (_jsx(ArrowRightSvg, __assign({}, props), void 0)); };
